const Card = ({className, children}) => {
  return <div className={`border ${className}`}>{children}</div>;
};

export default Card;
